import AppRouter from "../src/shared/Router";
import { styled } from "styled-components";
function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
